/** Shar vote/collection is enabled only when table shar amount is greater than zero. */
export function isSharEnabled(sharAmount?: number | string | null): boolean {
  return Math.max(0, Number(sharAmount) || 0) > 0;
}
